module.exports = __webpack_public_path__ + "img/lucas-logos_transparent.13e87232.png";